import React, { useEffect, useState } from "react";
import LogoCEA from "../assets/images/logo.png";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import SyncLoader from "react-spinners/SyncLoader";

// Link "Complete Payment" di email pendaftar mengarah ke sini, bukan langsung
// ke Midtrans. Backend hanya memberi URL Midtrans kalau link ini masih yang
// terbaru — link di email lama (mis. sebelum admin mengganti email) ditolak.
//
// Judul halaman mengikuti kondisinya, supaya pendaftar tidak bingung melihat
// "Complete Payment" padahal link-nya sudah tidak bisa dipakai.
const STATES = {
  expired: {
    icon: "bi-exclamation-triangle-fill",
    iconColor: "#d97706",
    iconBg: "#fff8e1",
    title: "Payment Link Expired",
    titleColor: "#231f20",
    fallbackText:
      "This payment link is no longer valid. Please use the payment link in the most recent email from Cutting Edge Academy, or contact our admin.",
  },
  paid: {
    icon: "bi-check-circle-fill",
    iconColor: "#16a34a",
    iconBg: "#f0fdf4",
    title: "Payment Already Completed",
    titleColor: "#231f20",
    fallbackText: "This registration has already been paid. No further payment is needed.",
  },
  error: {
    icon: "bi-x-circle-fill",
    iconColor: "#dc2626",
    iconBg: "#fef2f2",
    title: "Something Went Wrong",
    titleColor: "#231f20",
    fallbackText: "We couldn't open the payment page. Please try again later, or contact our admin.",
  },
};

const PayRedirect = () => {
  const navigate = useNavigate();
  const { orderId } = useParams();
  // null = sedang memeriksa link; selain itu salah satu kunci STATES.
  const [state, setState] = useState(null);
  const [message, setMessage] = useState("");

  useEffect(() => {
    axios
      .get(`/api/pay/${orderId}`)
      .then((res) => window.location.replace(res.data.redirectUrl))
      .catch((err) => {
        const data = err.response?.data || {};
        // Backend lama (tanpa `reason`) membalas 410 untuk link mati.
        const reason = data.reason || (err.response?.status === 410 ? "expired" : "error");
        setState(STATES[reason] ? reason : "expired");
        setMessage(data.msg || "");
      });
  }, [orderId]);

  const view = state ? STATES[state] : null;

  return (
    <div style={{ minHeight: "100vh", backgroundColor: "#f4f4f4", display: "flex", justifyContent: "center", alignItems: "center", padding: "40px 16px" }}>
      <div style={{ backgroundColor: "#fff", borderRadius: "14px", padding: "36px 28px", width: "100%", maxWidth: "440px", boxShadow: "0 4px 16px rgba(0,0,0,0.08)", textAlign: "center" }}>
        {!view ? (
          <>
            <img src={LogoCEA} alt="Cutting Edge Academy" style={{ width: "56px", height: "56px", objectFit: "contain", marginBottom: "12px" }} />
            <h4 style={{ fontWeight: 700, color: "#fb3104", marginBottom: "16px" }}>Complete Payment</h4>
            <div style={{ padding: "6px 0 14px" }}>
              <SyncLoader color="#fb3104" size={10} />
            </div>
            <p style={{ color: "#888", fontSize: "14px", margin: 0 }}>Redirecting you to the payment page…</p>
          </>
        ) : (
          <>
            <div
              style={{
                width: "64px",
                height: "64px",
                borderRadius: "50%",
                backgroundColor: view.iconBg,
                color: view.iconColor,
                fontSize: "30px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: "0 auto 16px",
              }}
            >
              <i className={`bi ${view.icon}`}></i>
            </div>
            <h4 style={{ fontWeight: 700, color: view.titleColor, marginBottom: "10px" }}>{view.title}</h4>
            <p style={{ color: "#666", fontSize: "14px", lineHeight: 1.6, margin: "0 0 22px" }}>{message || view.fallbackText}</p>
            <div style={{ display: "flex", flexDirection: "column", gap: "10px", alignItems: "center" }}>
              {state !== "paid" && (
                <a
                  href="https://wa.me/628984001333"
                  target="_blank"
                  rel="noreferrer"
                  style={{ display: "inline-block", minWidth: "200px", padding: "11px 24px", backgroundColor: "#fb3104", color: "#fff", borderRadius: "8px", fontWeight: 700, fontSize: "14px", textDecoration: "none" }}
                >
                  Contact Admin
                </a>
              )}
              <button
                type="button"
                onClick={() => navigate("/")}
                style={{ minWidth: "200px", padding: "10px 24px", backgroundColor: "transparent", color: "#555", border: "1px solid #ddd", borderRadius: "8px", fontWeight: 600, fontSize: "14px", cursor: "pointer" }}
              >
                Back to Homepage
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default PayRedirect;
